var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HomeVue"}},[_c('CommandBar'),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cytoContainContain"}},[_c('div',{attrs:{"id":"cytoscapeContainer"}})])}]

export { render, staticRenderFns }